/** Extract user-facing text from REST success/error payloads. */
export function messageFromApiResponse(data, fallback = "") {
  if (data == null) return fallback;
  if (typeof data === "string") {
    const trimmed = data.trim();
    return trimmed || fallback;
  }
  if (typeof data === "object") {
    if (typeof data.message === "string" && data.message.trim()) {
      return data.message.trim();
    }
    if (typeof data.error === "string" && data.error.trim()) {
      return data.error.trim();
    }
    if (data.error?.message) {
      return String(data.error.message);
    }
  }
  return fallback;
}

export function messageFromApiError(err, fallback) {
  return messageFromApiResponse(err?.response?.data, fallback) || err?.message || fallback;
}
